import {
	type MarketRegionResponseDto,
	type MarketRegionsUpdateDto,
	patchMarketsMarketIdRegionsId,
} from "Infrastructure/Api/Api";
import { processResponse } from "Infrastructure/Api/ApiUtils";
import { Resources, useResource } from "Infrastructure/Translation/Resources";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";
import { MARKET_REGION_LIST } from "../Query/useMarketRegionList";

const marketMutationsResource = Resources.base.market.mutations;

export const useUpdateRegionMutation = (
	marketId: number,
	marketRegionId: number,
) => {
	const { t } = useResource();
	const queryClient = useQueryClient();

	return useMutation({
		mutationFn: processResponse((data: MarketRegionsUpdateDto) =>
			patchMarketsMarketIdRegionsId(data, marketId, marketRegionId),
		),
		onError: (error) => {
			console.error(`${t(marketMutationsResource.updateRegionError)}:`, error);
		},
		onSuccess: (data: MarketRegionResponseDto) => {
			toast.success(t(marketMutationsResource.updateRegionSuccess));
			queryClient.invalidateQueries({
				queryKey: [MARKET_REGION_LIST, data.marketId],
			});
		},
	});
};
